import { ref } from "vue";
import { createApiClient } from "#/shared/api/client";

const api = createApiClient({ parse: false });

export function useWaitlistStore() {
  const formElement = ref();

  function isValid() {
    formElement.value.reportValidity();
    return formElement.value.checkValidity();
  }

  async function submitForm() {
    const url = formElement.value.action;

    const formData = new FormData(formElement.value);

    formData.append("waitlist", "true");

    const data = await api.post(url, formData);

    return data.confirmation_url;
  }

  function reset() {
    formElement.value?.reset();
  }

  return {
    setFormElement: (element) => (formElement.value = element),

    isValid,
    submitForm,
    reset,
  };
}
